import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';

import { BIGridComponent } from './components/BI-Grid/bi-grid.component';
import { BIChildGridComponent } from './components/BI-ChildGrid/bi-childGrid.component';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PagerModule } from '@progress/kendo-angular-pager';
import { FilterModule } from '@progress/kendo-angular-filter';
import { BiNavComponent } from './components/BI-Nav/bi-nav.component';
import { AlertModule } from '@full-fledged/alerts';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { BIGridLayoutComponent } from './components/bi-grid-layout/bi-grid-layout.component';
import { BIPopupComponent } from './components/BI-Popup/BI-Popup.component';
import { BIGridLayoutItemComponent } from './components/bi-grid-layout-item/bi-grid-layout-item.component';
import { BISideBarComponent } from './components/Bi-Side-bar/bi-side-bar.component';
import { IconsModule } from '@progress/kendo-angular-icons';
import { SideBarContentComponent } from './components/side-bar-content/side-bar-content.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';

import { BILookupComponent } from './components/BI-Lookup/bi-lookup.component';
import {
  InputsModule,
  NumericTextBoxModule,
} from '@progress/kendo-angular-inputs';
import { BIModalComponent } from './components/bi-modal/bi-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService, RTL } from '@progress/kendo-angular-l10n';
import '@progress/kendo-angular-intl/locales/ar/all';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/fa/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import {
  CldrIntlService,
  IntlModule,
  IntlService,
} from '@progress/kendo-angular-intl';
import { BiDropDownComponent } from './components/bi-drop-down/bi-drop-down.component';

import { MessageService } from '@progress/kendo-angular-l10n';
import { GetValuePipe } from './pipes/get-value.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BIDatePickerComponent } from './components/bi-date-picker/bi-date-picker.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { LoggerService } from './services/logger.service';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { SideBarErrorDetailsComponent } from './components/side-bar-error-details/side-bar-error-details.component';
import { DialogDirective } from './directives/dialog.directive';
import { ColorStatusDirective } from './directives/colors-status.directive';
import { BiDialog } from './components/bi-dialog/bi-dialog.component';
import { NegativeValueTransformPipe } from './pipes/negative-value-transform.pipe';
import { BiMasterGridDetailsComponent } from './components/bi-master-grid-details/bi-master-grid-details.component';
import { BiMasterGridDetailsChildrenComponent } from './components/bi-master-grid-details-children/bi-master-grid-details-children.component';
import { DatePipe } from '@angular/common';
import { BITreeComponent } from './components/bi-tree/bi-tree.component';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { BiAnchorPopupComponent } from './components/bi-anchor-popup/bi-anchor-popup.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { biRenderValidatorMsgComponent } from './components/bi-render-validator-msg/bi-render-validator-msg.component';
import { BIInterfacesModule } from 'bi-interfaces';
import { biControlListin2ColComponent } from './components/bi-control-list-2col/bi-control-list-2col';
import { BIGridStepsComponent } from './components/bi-grid-steps/bi-grid-steps.component';
import { BIGalleryComponent } from './components/bi-gallery/bi-gallery.component';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { biControlListComponent } from './components/bi-control-list/bi-control-list';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { BIPopupMenuComponent } from './components/bi-popup-menu/bi-popup-menu.component';
import { BISearchComponent } from './components/bi-search/bi-search.component';
import { SidebarSearchResultsComponent } from './components/sidebar-search-results/sidebar-search-results.component';
import { BiPhotoUploaderComponent } from './components/bi-photo-uploader/bi-photo-uploader.component';
import { BiLogoGalleryComponent } from './components/bi-logo-gallery/bi-logo-gallery.component';
import { BiAttachmentsComponent } from './components/bi-attachments/bi-attachments.component';
import { PasswordPipe } from './pipes/password.pipe';
import { BiMasterGridComposedComponent } from './components/bi-master-grid-composed/bi-master-grid-composed.component';
import { BiCardFilterComponent } from './components/bi-card-filter/bi-card-filter.component';
import { BiCardsComponent } from './components/bi-cards/bi-cards.component';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { BiCardNavComponent } from './components/bi-card-nav/bi-card-nav.component';
import { BiCardSorterComponent } from './components/bi-card-sorter/bi-card-sorter.component';
import {MatRadioModule} from '@angular/material/radio';import { BiFloatingInputsComponent } from './components/bi-floating-inputs/bi-floating-inputs.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { ValidationErrorToolTipComponent } from './validation-error-tool-tip/validation-error-tool-tip.component';
import { BiFloatingDropDownComponent } from './components/bi-floating-drop-down/bi-floating-drop-down.component';
import { BiFloatingLookupComponent } from './components/bi-floating-lookup/bi-floating-lookup.component';
import { BiFloatingColorPickerComponent } from './components/bi-floating-color-picker/bi-floating-color-picker.component';
import { BiFloatingTextAreaComponent } from './components/bi-floating-text-area/bi-floating-text-area.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import {MatMenuModule} from '@angular/material/menu';
import { UiProfileService } from './services/ui-profile.service';
import { BIGridColumnCustomizerComponent } from './components/bi-column-customizer/bi-column-customizer.component';
import { CdkDrag, CdkDropList, CdkDropListGroup, DragDropModule } from '@angular/cdk/drag-drop';
import { BiReportMangerMenuComponent } from './components/bi-report-manger-menue/bi-report-manger-menu.component';
import { BiChildReportComponent } from './components/bi-report-manger-menue/bi-child-report/bi-child-report.component';
import { BIFavoriteButtonComponent } from './components/BI-Favorite-Button/bi-favorite-button.component';
@NgModule({
  declarations: [
    BiNavComponent,
    BIGridComponent,
    BIChildGridComponent,
    BIGridLayoutComponent,
    BIGridLayoutItemComponent,
    BISideBarComponent,
    SideBarContentComponent,
    BILookupComponent,
    BIModalComponent,
    BiDropDownComponent,
    GetValuePipe,
    BIDatePickerComponent,
    BIPopupComponent,
    ErrorMessageComponent,
    SideBarErrorDetailsComponent,
    DialogDirective,
    BiDialog,
    NegativeValueTransformPipe,
    BiMasterGridDetailsComponent,
    BiMasterGridDetailsChildrenComponent,
    BITreeComponent,
    BiAnchorPopupComponent,
    biRenderValidatorMsgComponent,
    biControlListin2ColComponent,
    BIGridStepsComponent,
    BIGalleryComponent,
    biControlListComponent,
    BIPopupMenuComponent,
    BISearchComponent,
    SidebarSearchResultsComponent,
    BiPhotoUploaderComponent,
    ColorStatusDirective,
    BiLogoGalleryComponent,
    BiAttachmentsComponent,
    PasswordPipe,
    BiMasterGridComposedComponent,
    BiCardFilterComponent,
    BiCardsComponent,
    BiCardNavComponent,
    BiCardSorterComponent,
    BiFloatingInputsComponent,
    ValidationErrorToolTipComponent,
    BiFloatingDropDownComponent,
    BiFloatingLookupComponent,
    BiFloatingColorPickerComponent,
    BiFloatingTextAreaComponent,
    BIGridColumnCustomizerComponent,
    BiReportMangerMenuComponent,
    BiChildReportComponent,
    BIFavoriteButtonComponent
  ],
  imports: [
    AlertModule.forRoot({ maxMessages: 5, timeout: 5000, positionY: 'top' }),
    IconsModule,
    DateInputsModule,
    GridModule,
    HttpClientModule,
    ReactiveFormsModule,
    PagerModule,
    FilterModule,
    LayoutModule,
    ButtonModule,
    DropDownListModule,
    FormsModule,
    DialogsModule,
    InputsModule,
    ButtonsModule,
    PopupModule,
    NumericTextBoxModule,
    MatSnackBarModule,
    MatTooltipModule,
    TranslateModule,
    IntlModule,
    MatDatepickerModule,
    MatDialogModule,
    MatNativeDateModule,
    TreeViewModule,
    BIInterfacesModule,
    UploadsModule,
    NgxMaskPipe,
    NgxMaskDirective,
    FloatingLabelModule,
    ExcelModule,
    LayoutModule,
    ListViewModule,
    MatRadioModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule, 
    MatMenuModule,
    CdkDrag,
    CdkDropList,
    CdkDropListGroup,
  ],
  exports: [
    BiNavComponent,
    BIGridLayoutComponent,
    BIGridLayoutItemComponent,
    BISideBarComponent,
    SideBarContentComponent,
    BILookupComponent,
    TranslateModule,
    BIGridComponent,
    BIChildGridComponent,
    BiDropDownComponent,
    BIModalComponent,
    BIPopupComponent,
    ErrorMessageComponent,
    SideBarErrorDetailsComponent,
    BiMasterGridDetailsComponent,
    BiMasterGridComposedComponent,
    BITreeComponent,
    BiAnchorPopupComponent,
    biControlListin2ColComponent,
    BIGridStepsComponent,
    BIGalleryComponent,
    BiLogoGalleryComponent,
    biControlListComponent,
    BIPopupMenuComponent,
    BiPhotoUploaderComponent,
    BiCardsComponent,
    BiFloatingLookupComponent,
    BiCardFilterComponent,
    BiCardNavComponent,
    BIFavoriteButtonComponent
  ],
  providers: [
    provideNgxMask(),
     MessageService,
    LocalizationService,
    LoggerService,
    {
      provide: IntlService,
      useExisting: CldrIntlService,
    },
    {
      provide: "UIUserProfile",
      useExisting: UiProfileService,
    },
    {
      provide: LOCALE_ID,
      //  useValue: 'ar-EG',
      useFactory: () => localStorage.getItem('lang'),
    },
    CldrIntlService,

    GetValuePipe,
    NegativeValueTransformPipe,
    DatePipe,
    // {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}}
  ],
})
export class BIModulesModule { }
